export class AppSettings {
   
      /*public URL= 'http://localhost/backTHO/index.php/';
      public URLIMG= 'http://localhost/backTHO/images1/';
      public URLIMG2= 'https://admin.tuhogaronline.com/img/';*/

    public URL= 'https://admintho.aristextil.com/index.php/';
    public URLIMG= 'https://admintho.aristextil.com/images1/';
    public URLIMG2= 'https://admintho.aristextil.com/img/';   

    public static timeok= 10000;
    public static timeno= 10000;
    constructor( ) {
    }
 }



// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/helpers/config.ts